export const ROLE_ENUM = {
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  OPS_ADMIN: "OPS_ADMIN",
  FINANCE: "FINANCE"
}
